const fragmentPriceRangeFields = `
  fragment PriceRangeFields on PriceRange {
    maximum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
    minimum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
  }
`;

export default `
  query getProductPriceBySku(
    $filter: ProductAttributeFilterInput,
    $configurations: [ID!]
  ) {
    products(search:" ",filter: $filter) {
      items {
        id
        is_new
        engraving_enabled
        is_on_sale
        product_top_category
				manufacturer_main_category
				category_type_main_txt
				category_type_manufacturer_txt
        
        media_gallery {
          disabled
          label
          position
          url
          ... on ProductVideo {
            video_content {
              media_type
              video_provider
              video_url
              video_title
              video_description
              video_metadata
            }
          }
        }

        custom_attributes {
          attribute_metadata {
            code
            data_type
            entity_type
            label
            uid
          }
          selected_attribute_options {
            attribute_option {
              label
            }
          }
        }

        categories {
          uid
          name
          url_suffix
          url_path
          breadcrumbs_priority
          breadcrumbs {
            category_name
            category_url_path
          }
        }

        delivery_time
        show_discount_text
        product_discount_text

        price_range {
          ...PriceRangeFields
        }

        ... on ConfigurableProduct {
          configurable_options {
            attribute_code
            attribute_uid
            attribute_id
            label
            position
            uid
            use_default
            __typename

            values {
                label
                uid
                swatch_data {
                    value
                }
                value_index
                __typename
            }
          }

          variants {
            product {
                uid
                name
                sku
                stock_status

                media_gallery {
                  disabled
                  label
                  position
                  url
                }

                short_description {
                  html
                }
                description {
                  html
                }
                price_range {
                  ...PriceRangeFields
                }
            }
            attributes {
                code
                label
                uid
                value_index
            }
          }

          price_range {
            maximum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
            minimum_price {
              final_price {
                currency
                value
              }
              regular_price {
                currency
                value
              }
            }
          }

          configurable_product_options_selection(configurableOptionValueUids: $configurations) {
            options_available_for_selection {
              attribute_code
              option_value_uids
            }
            media_gallery {
              disabled
              label
              position
              url
            }
            variant {
              uid
              sku
              name
              short_description {
                html
              }
              description {
                html
              }
              price_range {
                ...PriceRangeFields
              }
            }
          }
        }

        ... on BundleProduct {
          items {
            position
            required
            sku
            title
            type
            uid
            options {
              can_change_quantity
              is_default
              position
              uid
              quantity
              product {
                uid
                sku
                name
                price_range {
                   ...PriceRangeFields
                }
              }
            }
          }
        }

        ... on GroupedProduct {
          items {
            position
            qty
            product {
              uid
              sku
              name
              stock_status
              only_x_left_in_stock
              price_range {
                maximum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
                minimum_price {
                  final_price {
                    currency
                    value
                  }
                  regular_price {
                    currency
                    value
                  }
                }
              }
              thumbnail {
                url
                position
                disabled
                label
              }
            }
          }
        }

      }
    }
  }
  ${fragmentPriceRangeFields}
`;
